// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import HolidayVillageRounded from '@mui/icons-material/HolidayVillageRounded';

// material ui
import { alpha } from '@mui/material';
import { green } from '@mui/material/colors';

// relative
import EnergyXplorerBaseCard from './EnergyXplorerBaseCard';

const PortfolioCard = ({ index = 0 }) => {
  const { t } = useTranslation('energy-analysis');
  const features = t('sales_cards.portfolio.features', {
    returnObjects: true,
  });
  const card = {
    title: t('sales_cards.portfolio.title'),
    subtitle: t('sales_cards.portfolio.subtitle'),
    description: t('sales_cards.portfolio.description'),
    icon: <HolidayVillageRounded sx={{ fontSize: 40 }} />,
    color: green[300],
    bgColor: alpha(green[300], 0.1),
    features: Array.isArray(features) ? features : [],
    learnMoreLink: 'https://www.remoni.com/portfolio-overview/',
    contactLink: 'https://www.remoni.com/contact/',
    chip: null,
    supportedDataTypes: ['Power', 'Water', 'Heat'],
  };

  return <EnergyXplorerBaseCard card={card} index={index} />;
};

export default PortfolioCard;
